import { Alert } from 'react-bootstrap';
import React from 'react';
import _ from 'lodash';

import { Meteor } from 'meteor/meteor';

import { Alerts } from '../../collections/alerts/alerts';
import {
  BPanel,
} from '@sketchpixy/rubix';

import { Reactive } from '../common/Reactive.mixin';

@Reactive({
	subscriptions: ["alerts"],
	alerts: Alerts.find({
		to: {
			$gte: new Date().toISOString(),
		},
		from: {
			$lte: new Date().toISOString()
		}
	})
})
export class AlertsViewer extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	getContent(content) {
		return (
			<span>
				{content.split("\n").map(function(item) {
					return (
						<p>
							{item}
						</p>
					)
				})}
			</span>
		)
	}

	renderAlert(alert) {
		if(alert.type == "Alerte") {
			return (
				<Alert bsStyle="danger">
					<p>{this.getContent(alert.content)}</p>
				</Alert>
			);
		} else if(alert.type == "Attention") {
			return (
				<Alert bsStyle="warning">
					<p>{this.getContent(alert.content)}</p>
				</Alert>
			);    		
		} else {
			return (
				<Alert bsStyle="info">
					<p>{this.getContent(alert.content)}</p>
				</Alert>
			);	
		}
	}

	renderAlerts() {
		let alerts = [];
		let user = Meteor.user();

		_.each(this.props.alerts, function(alert) {
			if (_.includes(alert.to_users, user._id) || _.intersection(alert.to_type, user.roles).length) {
				alerts.push(alert);
			}
		})


		return alerts.map((alert) => (
			<div>{this.renderAlert(alert)}</div>
		));
	}

	render() {
		return (
			<BPanel header="Alertes">
				<div className="alerts-viewer">
					{this.renderAlerts()}
				</div>
			</BPanel>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/components/alerts/AlertsViewer.js
 **/